import {Injectable} from '@angular/core';
import {CheckInAction} from '../../shared/models/check-in-action';
import {
  CheckInFlowData,
  CheckInFlowSignatureLink, hasCompletedAdultCheckIns, hasMissingAdultCheckIns,
  hasMissingCheckIns, hasMissingChildCheckIns,
  hasStartedCheckIns
} from '../../shared/models/check-in-flow.model';
import {CHECK_IN_TYPE} from '../../features/check-in-form/check-in-form.component';

@Injectable({providedIn: 'root'})
export class CheckInActionsService {
  constructor() {}

  getMinorCheckInAction(active: boolean) : CheckInAction {
    return {
      id: 'check-in-minor',
      label: 'Registrar viajero menor de edad',
      href: '/check-in-minor',
      data: {
        checkinType: CHECK_IN_TYPE.MINOR
      },
      disabled: !active,
    };
  }

  getAdultCheckInAction() : CheckInAction {
    return {
      id: 'check-in-mrz',
      label: 'Registrar viajero mayor de edad',
      href: '/check-in-mrz',
      data: {
        checkinType: CHECK_IN_TYPE.ADULT
      },
    };
  }

  getAdultSignatureCheckInAction(signatureLink: CheckInFlowSignatureLink) : CheckInAction {
    return {
      id: 'check-in-signature',
      label: 'Firmar check-in:',
      labelSuffix: signatureLink.name,
      href: '/check-in-signature',
      data: {
        travelRegisterId: signatureLink.travelRegisterId,
        contractUrl: signatureLink.contractUrl,
        email: signatureLink.email,
      },
    };
  }

  getMinorSignatureCheckInAction(signatureLink: CheckInFlowSignatureLink, enabled = true) : CheckInAction {
    return {
      id: 'check-in-signature-minor',
      label: 'Firmar check-in menor de edad:',
      labelSuffix: signatureLink.name,
      href: '/check-in-signature-minor',
      data: {
        travelRegisterId: signatureLink.travelRegisterId,
        email: signatureLink.email,
      },
      disabled: !enabled,
    };
  }

  getDepositCheckInAction() : CheckInAction {
    return {
      id: 'deposit-select-check-in',
      label: 'Pagar fianza',
      href: '/deposit-select-check-in'
    };
  }

  getCloseCheckInAction() : CheckInAction {
    return {
      id: 'close',
      label: 'Finalizar más tarde',
      href: '#blank'
    };
  }

  getCheckInActions(checkInFlowData: CheckInFlowData) {
    console.log('getCheckInActions', checkInFlowData);
    let actions: CheckInAction[] = [];
    if (hasMissingCheckIns(checkInFlowData)) {
      if (hasMissingAdultCheckIns(checkInFlowData)) {
        actions.push(this.getAdultCheckInAction());
      }
      if (hasMissingChildCheckIns(checkInFlowData)) {
        actions.push(this.getMinorCheckInAction(hasCompletedAdultCheckIns(checkInFlowData)));
      }
    }
    if (hasStartedCheckIns(checkInFlowData)) {
      if (checkInFlowData.pendingAdultSignatureLinks.length > 0) {
        checkInFlowData.pendingAdultSignatureLinks.forEach(signatureLink => {
          actions.push(this.getAdultSignatureCheckInAction(signatureLink));
        });

      }
      if (checkInFlowData.pendingMinorSignatureLinks.length > 0) {
        checkInFlowData.pendingMinorSignatureLinks.forEach(signatureLink => {
          actions.push(this.getMinorSignatureCheckInAction(signatureLink, hasCompletedAdultCheckIns(checkInFlowData)));
        });

      }
    }
    if (hasCompletedAdultCheckIns(checkInFlowData) && checkInFlowData.hasPendingDeposit) {
      actions.push(this.getDepositCheckInAction());
    }
    actions.push(this.getCloseCheckInAction());
    return actions;
  }
}
